import axios from "axios"
import { useState } from 'react';
//import { setCookie } from "nookies"
import './Login.css'
import { useProject } from "../Providers"
import { useHistory  } from "react-router-dom";
import {bgbutton} from "../common/ComUI.js";

export default function Login() {
	let history = useHistory();
	const {setUser } = useProject()
	const [isSignIn, setSignIn] = useState(true)
	const [form, setForm] = useState({
		name: "",
		email: "",
		password: "",
		password_confirmation: "",
		role:0,
		msg:"",
	})

	// const handleSignIn = () => {
	// 	for (const key in form)
	// 		if (!form[key] || form[key].length === 0)
	// 			switch (key) {
	// 				case "email":
	// 				case "password":
	// 					return console.log(key)
	// 			}
	// 	axios
	// 		.post(
	// 			`${process.env.NEXT_PUBLIC_API_URL}/users/login`,
	// 			{
	// 				username: form.email,
	// 				password: form.password,
	// 			},
	// 			{
	// 				withCredentials: true,
	// 			}
	// 		)
	// 		.then((res) => {
	// 			const cookie = JSON.parse(res.data.cookie)
	// 			setCookie(null, "user", res.data.cookie, {
	// 				maxAge: cookie.ttl,
	// 				path: "/",
	// 			})
	// 			setUser(cookie)
	// 			onClose()
	// 		})
	// }


	const handleChange = (e) =>{
		setForm({
			...form,
			[e.target.name]: e.target.value.trim(),
		})

	}

	const handleSubmit = async (event) => {
	  event.preventDefault();
	  try {

		const resp = await axios.post(`${process.env.REACT_APP_PUBLIC_API_URL}/users/login`,
		  {
			username : form.name,
			password : form.password,
		  }
		)
		localStorage.setItem('accessToken', resp.data.data.accessToken);
		localStorage.setItem('refreshToken', resp.data.data.refreshToken);
		localStorage.setItem('user', form);
		setUser(resp.data.data.user)

		//onClose()
		//history.push("/about");

	 } catch (err) {
		setForm({
			...form,
			msg: '로그인실패'
		})
	  }
	};

	const handleSignUp = async (event) => {
		for (const key in form) if (key != 'msg' && (!form[key] || form[key].length === 0)) return
		if(form.password_confirmation != form.password){
		 	return
		}
		event.preventDefault();
		try {
		  	const resp = await axios.post(`${process.env.REACT_APP_PUBLIC_API_URL}/users/signup`,
			{
				username : form.name,
				password : form.password,
				email : form.email,
				role : form.role,
			});

			//switchForm(!isSignIn)
		} catch (err) {
			alert(err.message);
		}	
	}

	const renderFeedbackMessage = () =>{
		if (form.password_confirmation) {
		  if (form.password_confirmation != form.password) {
			return (
			  <label>패스워드가 일치하지 않습니다</label>
			);
		  }
		}
	 }

	return(
		<form className='loginMessageBox' onSubmit={handleSubmit}>
			<div>
			<label style={{marginLeft:'100px',marginRight:'24px'}}>ID</label>
						<input
							type='text'
							name='name'
							placeholder='Your ID'
							maxLength='16'
				className='loginEdit'
				style={{width:'170px', height:'30px', marginTop:'80px'}}
							//className={style.modalInput}
							value={form.name}
							onChange={handleChange}
						/>
			</div>
			<div>
						<label style={{marginLeft:'100px',marginRight:'14px'}}>PW</label>
						<input
							type='password'
							name='password'
							placeholder='Your password'
				style={{width:'170px', height:'30px', marginTop:'10px'}}
							value={form.password}
							//className={style.modalInput}
							onChange={handleChange}
							// onChange={({ target: { value } }) => setPassword(value)}
						/>
				<input style={{visibility:'hidden'}} type='submit' />
			</div>
			{bgbutton("Login", handleSubmit)}
			<label style={{ marginLeft:'30px',color:"#C3602C"}} value={form.msg}>{form.msg}</label>
			{/* <div className='emptyButton'  key="c1" onClick={handleSubmit} />  */}
			
		</form>  
	)
}

